// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsMenu-cls1___5038aadc6451c489eb6{/*!*/}.ToolsMenu-cls2___15993318cf5abb52556{margin:22px 12px 4px;font-size:16px;font-weight:400;line-height:22px;letter-spacing:0em;display:flex;align-items:center;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsMenu-cls1___5038aadc6451c489eb6",
	"cls2": "ToolsMenu-cls2___15993318cf5abb52556 ToolsMenu-cls1___5038aadc6451c489eb6"
};
export default ___CSS_LOADER_EXPORT___;
